import { Box, IconButton } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import * as React from 'react';

import { MentorshipModuleIcon } from '../presentation/MentorshipModulePresentation';
import { MentorshipNotificationBadge } from './MentorshipNotifications';
import { useMentorshipNotifications } from './useMentorshipNotifications';

export const MentorshipNotificationIconButton: React.FC<{
  href: string;
  label?: string;
}> = ({ href, label = 'Open Mentorship notifications' }) => {
  const router = useRouter();
  const { notifications } = useMentorshipNotifications({ limit: 1 });

  return (
    <Box position="relative" flexShrink={0}>
      <IconButton
        aria-label={label}
        icon={<MentorshipModuleIcon module="notifications" boxSize="17px" />}
        size="sm"
        variant="outline"
        colorScheme="gray"
        bg="white"
        borderRadius="full"
        boxShadow="sm"
        onClick={() => router.push(href)}
      />
      {notifications?.unseenCount ? (
        <Box position="absolute" top="-7px" right="-8px" pointerEvents="none">
          <MentorshipNotificationBadge count={notifications.unseenCount} />
        </Box>
      ) : null}
    </Box>
  );
};
